<section class="toast__title mat-body-small">
	@if(process().status === PROCESS_STATUS.readyToDownload){
	<span>{{"Bereit zum Download" | translate : "headline-download-ready"}}</span>
	}
	@else {
	<span>{{"Vorgang gestartet" | translate : "headline-process-started"}}</span>
	}
</section>
<section class="process__details">
	<strong class="mat-label-large">
		{{process().type}} · {{process().name}} · {{process().contextName}}
	</strong>
</section>
@if(process().createdAt){
<app-date-time [date]="process().createdAt!" />
}
@if (process().status === PROCESS_STATUS.readyToDownload) {
<button mat-stroked-button (click)="onDownloadClick($event)">
	<ogs-m3-icon icon="download" matButtonIcon />
	{{"Download" | translate : "label-download"}}
</button>
}